import { render } from "./DetailsTagSearch.vue?vue&type=template&id=12386f83&scoped=true&ts=true"
import script from "./DetailsTagSearch.vue?vue&type=script&lang=ts"
export * from "./DetailsTagSearch.vue?vue&type=script&lang=ts"

import "./DetailsTagSearch.vue?vue&type=style&index=0&id=12386f83&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12386f83"]])

export default __exports__